import { getWithExpiry } from 'Helpers/getset-with-expiry'
import { omitBy, isNil } from 'lodash';

const useSession = () => {
  const session = getWithExpiry(process.env.APP_SESSION);

  const {
    accessToken,
    refreshToken,
    signature,
    roleTypes,
    roles,
    org,
    profile,
    pid
  } = session;
  
  return (omitBy({
    accessToken,
    refreshToken,
    signature,
    roleTypes,
    roles,
    org,
    profile,
    pid
  }, isNil))
}

export default useSession;
